import React from "react"
import LandbotChat from "./Components/LandbotChat"

export default function Dashboard() {
	return (
		<LandbotChat className="h-full w-full" />
	) 
}
